import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XrSession } from '../../../../models/session.model';

@Component({
  selector: 'app-session-spatial-target-panel',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex-1 overflow-y-auto p-4 space-y-4 custom-scrollbar">
      <div *ngIf="!session?.spatial_target" class="text-center py-12 text-gray-500 text-sm">
        No hay datos de spatial target en esta sesión.
      </div>

      <div *ngIf="session?.spatial_target" class="space-y-3">
        <div class="bg-black border border-zaxis-border rounded-none p-4 border border-zaxis-border space-y-2 overflow-hidden">
          <h4 class="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Objetivo Espacial</h4>
          <div class="flex justify-between text-sm gap-2">
            <span class="text-gray-400 flex-shrink-0">GameObject</span>
            <span class="text-white font-mono truncate text-right" [title]="session!.spatial_target!.gameObject_name">{{ session!.spatial_target!.gameObject_name }}</span>
          </div>
          <div class="flex justify-between text-sm gap-2">
            <span class="text-gray-400 flex-shrink-0">Tag</span>
            <span class="text-white truncate text-right" [title]="session!.spatial_target!.tag">{{ session!.spatial_target!.tag }}</span>
          </div>
          <div class="flex justify-between text-sm gap-2">
            <span class="text-gray-400 flex-shrink-0">Layer</span>
            <span class="text-white truncate text-right" [title]="session!.spatial_target!.layer">{{ session!.spatial_target!.layer }}</span>
          </div>
          <div class="flex justify-between text-sm gap-2">
            <span class="text-gray-400 flex-shrink-0">Distancia</span>
            <span class="text-white font-mono flex-shrink-0">{{ session!.spatial_target!.user_distance }}</span>
          </div>
        </div>

        <div *ngIf="session!.spatial_target!.available_interactions?.length" class="bg-black border border-zaxis-border rounded-none p-4 border border-zaxis-border">
          <h4 class="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Interacciones Disponibles</h4>
          <div class="flex flex-wrap gap-1.5">
            <span *ngFor="let interaction of session!.spatial_target!.available_interactions"
                  class="px-2 py-1 bg-purple-500/10 text-purple-300 border border-purple-500/20 rounded-none text-[10px] font-mono break-all"
                  [title]="interaction">
              {{ interaction }}
            </span>
          </div>
        </div>
      </div>
    </div>
  `
})
export class SessionSpatialTargetPanelComponent {
  @Input() session?: XrSession | null;
}
